import { useNavigate, useParams } from 'react-router-dom';
import { PATH_USER } from 'routes/paths';

const usePortalId = (): string => {
  const { portalId } = useParams<{ portalId: string }>();
  const navigate = useNavigate();

  if (!portalId) {
    navigate(PATH_USER.portals);

    return '';
  }

  return portalId;
};

export default usePortalId;
